// extracted by mini-css-extract-plugin
export default {"buttontariff":"BasicCard_buttontariff__8MHFe"};